// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"08e2238e","209":"61c57fbe","405":"340e317c","414":"75a18da0","453":"d3ff1ed3","630":"b7d7f749","704":"2fa57064","833":"f7ae5698","836":"406859d8"}[chunkId] + ".chunk.js";
};